import { EventCard } from '../event-card';
import { MarketCard, MarketCardSkeleton } from '../market-card';
import { adaptEventDetailMarket } from '../market-chart-sections/event-section-card';
import { api } from '@/client/utils/api';
import { useEventDetail } from '@/libs/react-sdk/api/use-event-detail';
import { useMemo } from 'react';

type Props = {
  eventId: string;
  index: number;
};

// One curated pin from the Trending rail section. The section payload only
// carries the event id, so each pin fetches its own event detail and reuses
// the same EventDetailMarket -> Market adapter MarketChartSection uses.
export const TrendingSectionEntry = ({ eventId, index }: Props) => {
  const { data: eventDetail, isLoading } = useEventDetail(api, { eventId });

  const markets = useMemo(() => {
    if (!eventDetail) return [];
    return eventDetail.markets.map(m => adaptEventDetailMarket(m, eventId, eventDetail.collateral));
  }, [eventDetail, eventId]);

  if (isLoading) return <MarketCardSkeleton />;
  if (markets.length === 0) return null;

  return markets.length > 1 ? (
    <EventCard eventId={eventId} markets={markets} />
  ) : (
    <MarketCard market={markets[0]} index={index} />
  );
};
